import * as z from "zod/v4";

export const completeMobileUpload = {
  name: "completeMobileUpload" as const,
  input: z.object({ token: z.string() }),
  output: z.object({ success: z.boolean() }),
};
